// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__6KG_Q","productName":"Table_productName__1kHSI"};